export default __webpack_public_path__ + "static/media/ncr-logo-eps.58dc90e4.svg";